export const CONFIG = {
    client_name : "stw_duisburg",
    client_display_name : "Stadtwerke Duisburg",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/stw_duisburg/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "47051",
    foerderung : true,
    development_mode: false,
}